var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
		'el-check-icon',
		_vm.isValid ? '-valid' : '-not-valid'
	]},[_c('div',{class:[
		_vm.isValid ? '-tick' : '-cross'
	]})])}
var staticRenderFns = []

export { render, staticRenderFns }